import React from "react";
import IndexedFormRow from "../IndexedFormRow";
import CollapseContainer from "../../CollapseContainer/CollapseContainer";
import AddressForm from "../AddressForm/AddressForm";
import "./styles.scss";
import { Translate } from "react-localize-redux";

const defaultAddress = {
  street_number: "",
  unit_number: "",
  street: "",
  neighbourhood: "",
  country: "",
  state_prov: "",
  city_district: "",
  postal_zip: "",
  other: null,
  category: "Home",
  order_index: 0,
  street_number_privacy: "MC",
  unit_number_privacy: "MC",
  street_privacy: "MC",
  neighbourhood_privacy: "MC",
  country_privacy: "PU",
  state_prov_privacy: "PU",
  city_district_privacy: "PU",
  postal_zip_privacy: "MC",
  other_privacy: "MC"
};

const AddressFormPanel = () => (
  <CollapseContainer
    title={<Translate id="Addresses" />}
    startCollapsed={false}
  >
    <IndexedFormRow
      modelArrayName="addresses"
      privacyRow={
        <div className="row">
          <div className="col-9" />
          <div className="col-2 address-privacy-label-container">
            <h4 className="address-privacy-label">
              <Translate id="PrivacyText" />
            </h4>
          </div>
        </div>
      }
      defaultEntry={defaultAddress}
      showCategory={false}
      showPrivacy={false}
      showRemove
      dataComponent={(member, dataObj) => (
        <AddressForm member={member} address={dataObj} />
      )}
    />
  </CollapseContainer>
);

export default AddressFormPanel;



// WEBPACK FOOTER //
// ./src/components/forms/AddressFormPanel/AddressFormPanel.jsx